import { AUTOMATIC_STRATEGY_PERMISSIONS } from "../selector";

/**
 * Resolves the plan permissions guarding an automatic strategy's content.
 *
 * Strategies whose stored notifications_unique_id happens to match their plan
 * permission codename (Donchian) resolve through the derived fallback, while
 * strategies that carry the backend's content-type prefix (Highs & Lows,
 * Supply/Demand) need an explicit AUTOMATIC_STRATEGY_PERMISSIONS entry.
 *
 * The fallback must stay the derived permission and never an empty array:
 * hasPermissionRedux checks with `.every()`, so an empty list grants access to
 * everyone.
 */
const resolveAutomaticStrategyPermissions = notificationsUniqueId =>
  AUTOMATIC_STRATEGY_PERMISSIONS[notificationsUniqueId] ?? [
    `plans.${notificationsUniqueId}`
  ];

export default resolveAutomaticStrategyPermissions;
